import React from "react";
import { Routes, Route } from "react-router-dom";
import Apps from "./apps/Apps";
import Login from "./apps/Security/Login";
import { Toaster } from "react-hot-toast";
import { useLocation } from "react-router-dom";
import Forgotlogin from "./apps/Security/Forgotpassword";
import Changepassword from "./apps/Security/Changepassword";
import DailyTaskApproval from "./apps/Approvals/DailyTaskApproval";
import NotificationPage from "./ui-components/Notification";
import PermissionApproval from "./apps/Approvals/PermissionApproval";
import LeaveApproval from "./apps/Approvals/LeaveApproval";
import Otapproval from "./apps/Approvals/OtApproval";
import Ondutyapproval from "./apps/Approvals/OndutyApproval";
import Salaryadvanceapproval from "./apps/Approvals/SaladvanceApproval";
import Expenseapproval from "./apps/Approvals/ExpenseApproval";
import Regularizationaproval from "./apps/Approvals/RegularizeApproval";
import UnderMaintenance from "./apps/pages/UnderMaintanance";

const App = () => {
  const location = useLocation();
  if (location.pathname === "/") {
    window.history.pushState(null, document.title, "#");
  }
  return (
    <React.Fragment>
      <Toaster position="top-center" reverseOrder={false} />
      <Routes>
        {/* <Route path="/*" element={<UnderMaintenance />} /> */}
        <Route path="/*" element={<Login />} />
        <Route path="/Forgotpassword" element={<Forgotlogin />} />
        <Route path="/changepassword" element={<Changepassword/>} /> 
        <Route path="/task-approval/:id/:managerID" element={<DailyTaskApproval/>} /> 
        <Route path="/permission-approval/:id/:managerID" element={<PermissionApproval/>} /> 
        <Route path="/leave-approval/:id/:managerID" element={<LeaveApproval/>} /> 
        <Route path="/overtime-approval/:id/:managerID" element={<Otapproval/>} /> 
        <Route path="/onduty-approval/:id/:managerID" element={<Ondutyapproval/>} />
       <Route path="/salaryadvance-approval/:id/:managerID" element={<Salaryadvanceapproval/>} />
        <Route path="/financeentry-approval/:id/:managerID" element={<Expenseapproval/>} />
        <Route path="/regularization-approval/:id/:managerID" element={<Regularizationaproval/>} />
      <Route path="/approval/notification/:type/:status" element={<NotificationPage/>} /> 
        <Route path="/Apps/*" element={<Apps />} />
      </Routes>
    </React.Fragment>
  );
};

export default App;
